/*
 * validation共通処理mixin
 */
<script>
// フォーム入力制限の定数ファイル読み込み
import * as comData from 'js/const/constants';

export default {
	props:[
	],
	computed:{
		CHKTYPE_NULL:function(){return 0;},		//!< NULLチェック
		CHKTYPE_NUMBER:function(){return 1;},	//!< 数値チェック
		CHKTYPE_TEXT:function(){return 2;},		//!< 禁止文字が含まれていないかチェック
		CHKTYPE_CODE:function(){return 3;},		//!< 数値が有効範囲に含まれるかチェック
		CHKTYPE_DECLEN:function(){return 4;},	//!< 小数の桁数チェック
		CHKTYPE_TXTLEN:function(){return 5;},	//!< 文字列長さチェック
		CHKTYPE_KANA:function(){return 6;},		//!< ひらがなチェック
		CHKTYPE_TEL:function(){return 7;},		//!< 電話番号チェック
		CHKTYPE_ALPHANUM:function(){return 8;},	//!< 英数字チェック
		CHKTYPE_MLINE:function(){return 9;},	//!< 複数行チェック ※1行の最大＆行数
		CHKTYPE_ZIP:function(){return 10;},		//!< 郵便番号チェック
		CHKTYPE_DATE:function(){return 11;},	//!< 日付チェック
		CHKTYPE_MATCH:function(){return 12;},	//!< 指定した文字列に一致しないかチェック
		CHKTYPE_HALF:function(){return 13;},	//!< 半角英数字記号チェック
		CHKTYPE_WIDE:function(){return 14;},	//!< 全角チェック
		CHKTYPE_INTEGRAL_NUMBER:function(){return 15;},	//!< 数値(マイナス含む)チェック
		CHKTYPE_TXTLEN2:function(){return 16;},	//!< 文字列長さチェック CRLFをLFとしてカウント
		CHKTYPE_CODE_STRING:function(){return 17;},		//!< 数値が有効範囲に含まれるか文字列としてチェック
		CHKTYPE_IP_ADDRESS: function(){return 18;},		// IPアドレスとして正しいかチェック
		CHKTYPE_DATETIME:function(){return 19;},	// 日付チェック
		CHKTYPE_TIME:function(){return 20;},	//!< 時刻チェック
		CHKTYPE_FILE_NAME: function(){return 21;}	// 半角英数字記号(アンダーバー、ハイフン、ドットのみ許容)チェック
	},
	methods: {
		//! 文字列チェックの実行 パラメータを選別
		checkString:function(type,value,max,min,len,prm){
//console.log("checkString : " + type);
			switch(type){
				case this.CHKTYPE_NULL:// Nullチェック
					if(typeof value != "string")value = value + "";
					if(value.length == 0)return false;
					return true;
				case this.CHKTYPE_NUMBER:// 数値
					return this.checkStringNumber(value);
				case this.CHKTYPE_TEXT: 
					return this.checkStringText(value);
				case this.CHKTYPE_CODE: // 数値の有効範囲check
					return this.checkStringCode(value,max,min);
				case this.CHKTYPE_DECLEN:// 小数
					var str = max.toString().split('.');
					var nLen = str[0]?str[0].length:2; // 整数部の桁数上限
					var fLen = str[1]?str[1].length:0; // 小数部の桁数上限
					return this.checkStringDecimalLength(value,nLen,fLen);
				case this.CHKTYPE_TXTLEN://
					return this.checkStringTextLength(value,len,0);
				case this.CHKTYPE_TXTLEN2://
					return this.checkStringTextLength(value,len,1);
				case this.CHKTYPE_KANA:
					return this.checkStringKana(value);
				case this.CHKTYPE_TEL:
					return this.checkStringTelephone(value);
				case this.CHKTYPE_ALPHANUM:
					return this.checkStringAlphaNum(value);
				case this.CHKTYPE_MLINE:
					return this.checkStringMultiLine(value,max,len);
				case this.CHKTYPE_ZIP:
					return this.checkStringZip(value);
				case this.CHKTYPE_DATE:
					return this.checkStringDate(value);
				case this.CHKTYPE_MATCH:// prm に一致したらエラー
					if(value == prm){return false;}
					break;
				case this.CHKTYPE_HALF:
					return this.checkStringHalf(value);
				case this.CHKTYPE_WIDE:
					return this.checkStringWide(value);
				case this.CHKTYPE_INTEGRAL_NUMBER:
					return this.checkStringIntegralNumber(value);
				case this.CHKTYPE_CODE_STRING:
					return this.checkStringCodeString(value, max, min);
				case this.CHKTYPE_IP_ADDRESS:
					// IPアドレス
					return this.checkStringIPAddress(value);
				case this.CHKTYPE_DATETIME:
					// 日付
					return this.checkStringDateTime(value);
				case this.CHKTYPE_TIME:
					// 時刻(4桁)
					return this.checkStringTime(value);
				case this.CHKTYPE_FILE_NAME:
					// 半角英数字記号(アンダーバー、ハイフン、ドットのみ許容)
					return this.checkStringFileName(value);
			}
			return true;
		},
		//! 数値チェック
		checkStringNumber: function ( value ){
			do{
				value = value +"";

				if(value.indexOf("-") == 0){
					value = value.slice(1);
				}

				var myRe = new RegExp("[^0-9]");
				var myArray = myRe.exec(value);
				if (myArray !=null)break;//!< 数値以外を発見
				return true;
			}while(false);
console.log("checkStringNumber Error! : " + value);
			return false;
		},
		/**
		 * テキストチェック
		 */
		checkStringText: function ( value ){
			do{
				value = value + "";
				if(typeof value != "string"){// 文字列ではない
					break;
				}

				// 特殊文字が含まれているならエラーにする
				var kigou = comData.KIGOU;
				var myRe = new RegExp("[" + kigou+ "]");
				var myArray = myRe.exec(value);
				if (myArray != null )break; // 特殊文字発見

				return true;
			}while(false);
console.log("checkStringText Error! : " + value);
			return false;
		},
		/**
		 * 数値のマックスとミニマムをチェック
		 */
		checkStringCode: function ( value, code_max, code_min ){
//console.log("checkStringCode value=" + value +", max=" + code_max + ", min=" + code_min);
			var errMessage = "";
			do{
				
				if (!(typeof value == "string" && value == "")){// 空文字は許容されるので除外
					if(code_max != undefined && code_max !="" && Number(value) > code_max) break;
					if(code_min != undefined && Number(value) < code_min)break;//!< 範囲チェック
				}
				return true;
			}while(false);
console.log("checkStringCode Error! : " + value);
			return false;
		},
		/**
		 * 小数のバリデーションcheck
		 */
		checkStringDecimalLength: function ( value,  maxLength, maxFraLength ){
			
			do{
				if(typeof value != "string"){
					if(value){
						// 文字列に変換
						value = value.toString();
					}else{value = "";};
				}
					
				var arr = value.split('.');
				if( arr.length >2 )break;//!< ドットが2つ以上
				
				if(arr.length != 0){
					var reg = new RegExp("[^0-9]");
					if( arr[0].length > maxLength)break;	//!< 長さチェック
					if( reg.exec(arr[0]) != null )break;	//!< 数値以外

					if(arr.length == 2){
						if( arr[1].length > maxFraLength)break;	//!< 長さチェック
						if( reg.exec(arr[1]) != null )break;	//!< 数値以外
					}
				}
				return true;
			}while(false);
console.log("checkStringDecimalLength Error! : " + value);
			return false;
		},
		/**
		 * 文字列の長さをチェック
		 */
		checkStringTextLength: function ( value, max_length, type = 0 ){
			do{
				/*if(typeof value != "string")break;*/	//!< タイプチェック
				if (type == 0) {
					if((value+"").length > max_length) {
						break;	//!< 長さチェック
					}
				} else {
					// CRLFをLF一文字としてカウント
					var str = new String(value);
					if(str.replace(/\r?\n/g, '\n').length > max_length) {
						break;	//!< 長さチェック
					}
				}
				return true;
			}while(false);
			value = value + "";
console.log("checkStringTextLength Error! : len=" + value.length + " > " + max_length);
			return false;
		},
		/**
		 * ひらがな のみ許可
		 */
		checkStringKana: function(value){
			do{
				if(typeof value != 'string'){
					break;
				}

				// ひらがな以外があればエラー
				const myRe = new RegExp('[^あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわをん]');
				const myArray = myRe.exec(value);
				if(myArray != null){
					// ひらがな以外が存在
					break;
				}
				return true;
			}while(false);
			console.log("checkStringKana Error! : " + value);
			return false;
		},
		/**
		 * 電話番号チェック
		 */
		checkStringTelephone: function ( value){
			do{
				if(typeof value != "string")break;
				if(value == "")return true;

				var myRe = new RegExp("(^[-])|--|([-]$)");
				var myArray = myRe.exec(value);
				if ( myArray != null )break; 
				return true;
			}while(false);
console.log("checkStringTelephone Error! : " + value);
			return false;
		},
		//! 半角英数字 判定
		checkStringAlphaNum: function ( value){
			do{
				value = value +"";

				var myRe = new RegExp("[^a-zA-Z0-9]");
				var myArray = myRe.exec(value);
				if ( myArray != null )break;
				return true;
			}while(false);
console.log("checkStringAlphaNum Error! : " + value);
			return false;
		},
		//! 半角英数字 記号 判定
		checkStringHalf: function ( value){
			do{
				value = value +"";

				var myRe = new RegExp("[^\x20-\x7E},./\]");
				var myArray = myRe.exec(value);
				if ( myArray != null )break;
				return true;
			}while(false);
console.log("checkStringHalf Error! : " + value);
			return false;
		},
		//! 全角 判定
		checkStringWide: function ( value){
			do{
				value = value +"";

				var myRe = new RegExp("[\x01-\x7E]");
				var myArray = myRe.exec(value);
				if ( myArray == null )break;
				return true;
			}while(false);
console.log("checkStringWide Error! : " + value);
			return false;
		},
		//! 複数行チェック
		checkStringMultiLine:function(value,maxLine,//!< 最大行数
										maxLineLen //!<	 1行の最大長
										){
			do{
				if(typeof value != "string")break;

				while(value.indexOf("\r\n") >= 0){
					value =	value.replace("\r\n" , "\n");
				}
				var arrLine = value.split("\n");

				if(arrLine.length > maxLine)break;

				var ret = true;
				for(var line in arrLine){
					if( arrLine[line].length > maxLineLen){
						ret = false;
						break;
					}
				}

				return ret;
			}while(false);
console.log("checkStringMultiLine Error! : " + value);
			return false;			

		},
		//! 郵便番号チェック
		checkStringZip: function ( value){
			do{
				if(typeof value != "string")break;
				if(value == "")return true;

				var myRe = new RegExp("^[0-9]{3,3}-?[0-9]{4,4}$");
				var myArray = myRe.exec(value);
				if ( myArray == null )break;
				return true;
			}while(false);
console.log("checkStringZip Error! : " + value);
			return false;
		},
		//! 日付入力チェック
		checkStringDate: function ( value){
			do{
				if(typeof value != "string")break;
				if(value == "")return true;

				var myRe = new RegExp("^[0-9]{4,4}-?[0-9]{2,2}-?[0-9]{2,2}$");
				var myArray = myRe.exec(value);
				if ( myArray == null )break;
				return true;
			}while(false);
console.log("checkStringDate Error! : " + value);
			return false;
		},
		//! 数値（マイナス含む）チェック
		checkStringIntegralNumber: function ( value ){
			do{
				value = value +"";

				var myRe = new RegExp("^[-]?[0-9]");
				var myArray = myRe.exec(value);
				if (myArray == null)break;//!< 数値以外を発見
				return true;
			}while(false);
console.log("checkStringIntegralNumber Error! : " + value);
			return false;
		},
		/**
		 * 数値のマックスとミニマムをチェック
		 */
		checkStringCodeString: function(value, code_max, code_min){
			let errMessage = "";
			do{
				let sValue = "";
				if(value != undefined){
					sValue = value + "";
				}else{
					break;
				}

				if(sValue !== ""){// 空文字は許容されるので除外
					// 最大値チェック
					let sCodeMax = "";
					if(code_max != undefined && code_max != ""){
						sCodeMax = code_max + "";
					}else{
						break;
					}
					const valueMax = sValue.padStart(sCodeMax.length, "0");
					if(valueMax > sCodeMax){
						break;
					}

					// 最小値チェック
					let sCodeMin = "";
					if(code_min != undefined && code_min != ""){
						sCodeMin = (code_min + "").padStart(sCodeMax.length, "0");
					}else{
						break;
					}
					const valueMin = sValue.padStart(sCodeMax.length, "0");
					if(valueMin < sCodeMin){
						break;
					}
				}
				return true;
			}while(false);
			console.log("checkStringCodeString Error! : " + value);
			return false;
		},
		// IPアドレスチェック
		checkStringIPAddress: function(value){
			do{
				const myRe = new RegExp("^(((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9]))?$");
				const myArray = myRe.exec(value);
				if(myArray == null){
					// IPアドレスの形式に合致しない
					break;
				}
				return true;
			}while(false);
			console.log('checkStringIPAddress Error! : ' + value);
			return false;
		},
		// 日付入力チェック
		checkStringDateTime: function(value){
			do{
				if(typeof value != 'string'){
					break;
				}
				if(value == ''){
					return true;
				}

				const myRe = new RegExp("^[0-9]{4,4}-?[0-9]{2,2}-?[0-9]{2,2}( ?[0-9]{2,2}:?[0-9]{2,2}:?[0-9]{2,2})?$");
				const myArray = myRe.exec(value);
				if(myArray == null){
					break;
				}
				return true;
			}while(false);
			console.log('checkStringDateTime Error! : ' + value);
			return false;
		},
		// 時刻入力チェック
		checkStringTime: function(value){
			do{
				if(typeof value != 'string'){
					break;
				}
				if(value == ''){
					return true;
				}

				const myRe = new RegExp("^([01][0-9]|2[0-3])[0-5][0-9]$");
				const myArray = myRe.exec(value);
				if(myArray == null){
					break;
				}
				return true;
			}while(false);
			console.log('checkStringTime Error! : ' + value);
			return false;
		},
		// 半角英数字記号(アンダーバー、ハイフン、ドットのみ許容)
		checkStringFileName: function(value){
			do{
				const myRe = new RegExp("[^a-zA-Z0-9\x2D\x2E\x5F]");
				const myArray = myRe.exec(value);
				if(myArray == null){
					break;
				}
				return true;
			}while(false);
			console.log('checkStringFileName Error! : ' + value);
			return false;
		}
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/validate/checkString.mixin.vue